import React, {useMemo, useState, useEffect} from 'react';
/*
  Takes a integer|float as an input 
  Returns a formatted number in fund specific format read from context
*/
const FormattedNumber = ({number, round = false, number_format, rollingNumberAnimation = false, onRolled}) => {
  if (number === void 0) return null 
  if (isNaN(number)) return number; 

  if (!rollingNumberAnimation) {
    const formattedNumber = useMemo(() => formatNumber(roundNumber(number, round), number_format), [number, round]);
    return formattedNumber;  
  }

  const absoluteNumber = Math.abs(number); // handle rolling as non-negative until displaying
  const [rollingNumber, setRollingNumber] = useState(0);
  const rollingDelay = 20;
  const extraStepsForLargerNumbers = 5 * Math.floor( Math.log10(absoluteNumber) );
  const rollingStepAmount = 40 + extraStepsForLargerNumbers;
  const rollingInterval = (absoluteNumber < rollingStepAmount) ? 1 : Math.floor(absoluteNumber / rollingStepAmount);

  useEffect(() => {
    if (!rollingNumberAnimation) return;
    if (rollingNumber === absoluteNumber){
      onRolled?.();
      return;
    };
    setTimeout(() => {
      setRollingNumber(rollingFrom => {
        const rollingDone = Math.abs(rollingFrom) + rollingInterval > absoluteNumber;
        if (rollingDone) return number;
        if (number < 0) return rollingFrom - rollingInterval;
        return rollingFrom + rollingInterval;
      } );
   }, rollingDelay);
  }, [rollingNumber, number]);

  return formatNumber(roundNumber(rollingNumber, round), number_format);
}

export default FormattedNumber;

export const formatNumber = (number, number_format=null) => SmartME.formatNumber(number, number_format ? number_format : document.body.getAttribute("data-number-format"));

export const roundNumber = (number, round) => {
  let roundFactor = "1";

  if (round) {
    for (let i = 0; i < round; ++i) {
      roundFactor = `${roundFactor}0`;
    }
  }

  roundFactor = parseInt(roundFactor, 10);

  return round || round === 0 ? Math.round(number * roundFactor) / roundFactor : number;
};